var React = require('react');

function ChevronPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 1.5197L9.33162 -1.45854e-07L1.93519e-06 8.5L9.33162 17L11 15.4803L3.33676 8.5L11 1.5197Z","fill":"#ED1C24"}));
}

ChevronPrev.defaultProps = {"width":"11","height":"17","viewBox":"0 0 11 17","fill":"none"};

module.exports = ChevronPrev;

ChevronPrev.default = ChevronPrev;
